// extracted by mini-css-extract-plugin
export default {"layoutContent":"Content_layoutContent__boEK5"};